import * as React from "react";
import { Grid, List, ListItemButton, ListItemText, Alert, CircularProgress, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";

import DrawerScaffold from "../../app/components/scaffold/DrawerScaffold";
import MainDrawerContent from "app/components/drawer/MainDrawerContent";
import withAppVersion, { WithAppVersionProps } from "features/appVersion/withAppVersion";

import { pb } from "./../../utils/pocketbase";
import type { WikiRecord, ListResponse } from "./../../utils/types";
import Routes from "app/routes/Routes";

const COLLECTION = "wiki";

const VorsorgeWiki: React.FC<WithAppVersionProps> = () => {
    const history = useHistory();

    const [items, setItems] = React.useState<WikiRecord[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState<string | null>(null);

    React.useEffect(() => {
        let alive = true;

        (async () => {
            try {
                setLoading(true);
                setError(null);

                // PocketBase: getList(page, perPage, options)
                const res = await pb.collection(COLLECTION).getList<WikiRecord>(1, 30, {
                    // optional: nur aktivierte Einträge
                    filter: "enabled = true",
                    sort: "-sort",
                    query: { _ts: Date.now() }, // cache-buster
                });

                // res entspricht typischerweise { page, perPage, totalPages, totalItems, items }
                const typed = res as unknown as ListResponse<WikiRecord>;

                if (alive) setItems(typed.items ?? []);
            } catch (e: any) {
                if (alive) setError(e?.message ?? "Fehler beim Laden der Wiki-Liste.");
            } finally {
                if (alive) setLoading(false);
            }
        })();

        return () => {
            alive = false;
        };
    }, []);

    return (
        <DrawerScaffold
            title={"Vorsorge Wiki"}
            actions={<></>}
            drawerContent={<MainDrawerContent />}
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    {loading && <CircularProgress size={24} />}

                    {error && (
                        <Alert severity="error">
                            {error}
                        </Alert>
                    )}

                    {!loading && !error && items.length === 0 && (
                        <Alert severity="info">Keine Einträge gefunden.</Alert>
                    )}

                    {!loading && !error && items.length > 0 && (
                        <List
                            disablePadding
                            style={{ marginLeft: '-16px' }}
                        >
                            {items.map((it) => (
                                <ListItemButton
                                    key={it.id}
                                    onClick={() => history.push(`${Routes.VorsorgeWiki}/${encodeURIComponent(it.id)}`)}
                                    divider
                                >
                                    <ListItemText
                                        primary={it.teaser || it.title || it.id}
                                    />
                                </ListItemButton>
                            ))}
                        </List>
                    )}
                </Grid>
            </Grid>
        </DrawerScaffold>
    );
};

export default withAppVersion(VorsorgeWiki);
